module.exports = __webpack_public_path__ + "img/vip-banner-bg.a742eab0.png";